import React, { useEffect } from "react";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import Socials from "../components/about/socials";
import Seo from "../components/common/seo";

import INFO from "../data/user";
import { personSchema, serviceSchema } from "../data/schema";

import "./styles/contact.css";

const Contact = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<React.Fragment>
			<Seo page="contact" schema={[personSchema, serviceSchema]} />

			<div className="page-content">
				<NavBar active="contact" />
				<div className="content-wrapper">
					<div className="contact-logo-container">
						<div className="contact-logo">
							<Logo width={46} />
						</div>
					</div>

					<main className="contact-container">
						<h1 className="title contact-title">
							{INFO.contact.title}
						</h1>

						<div className="subtitle contact-subtitle">
							{INFO.contact.description}
						</div>

						<div className="contact-link-grid">
							{INFO.contact.links.map((link) => (
								<a
									className="contact-link-card"
									href={link.href}
									key={link.label}
									target={link.href.startsWith("http") ? "_blank" : undefined}
									rel={link.href.startsWith("http") ? "noopener noreferrer" : undefined}
								>
									<strong>{link.label}</strong>
									<span>{link.value}</span>
								</a>
							))}
						</div>
					</main>

					<div className="socials-container">
						<div className="contact-socials">
							<Socials />
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Contact;
